export default __webpack_public_path__ + "static/media/product-big.2b83e9b5.png";